module.exports = __webpack_public_path__ + "img/Dantam Hair 10.19d2dc86.jpg";